import { Button, Drawer, Skeleton, Checkbox, TreeSelect, Card, Spin } from "antd";
import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { useStoreUpdaterWithAPI } from "../../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../../Common/APIConstants";
import CustomDrawer from "../../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../../Elements/CustomSelect";
import SteamTreeSelectCustomWithSelectAll from "../../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import SteamTreeSelectCustom from "../../../../../../Elements/TreeSelect/TreeSelectCustom";
import { calculateDateRangeFromDate } from "../../../../../../../Utils/DateConverstion";
import { useSelector } from "react-redux";

const SteamLiveChart = () => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState();
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState();
  const [selectedValues, setSelectedValues] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [seriesChartData, setSeriesChartData] = useState();
  const [chartTime, setChartTime] = useState();
  const [singleMeterName, setSingleMeterName] = useState();
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [chartSkip, setChartSkip] = useState(true);
  const [chartInput, setChartInput] = useState();
  const [submitClicked, setSubmitClicked] = useState(false);
  const [flowSectionList, setFlowSectionList] = useState([]);
  const [flowConverterList, setFlowConverterList] = useState([]);

  const [flowGroupDetailList, setFlowGroupDetailList] = useState([]);
  const [nsFlowConverterList, setNsFlowConverterList] = useState([]);

  const [steamGroupMeterList, setSteamGroupMeterList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);


  const [steamConverterLiveChartData, setSteamConverterLiveChartData] =
    useState([]);

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const [chartData, setChartData] = useState({
    series: [
      {
        name: "",
        data: [],
      },
    ],

    options: {
      chart: {
        height: 350,
        type: "line",
        zoom: {
          type: "x",
          enabled: true,
          // autoScaleYaxis: true,
        },
        animations: {
          enabled: true,
          easing: "linear",
          dynamicAnimation: {
            speed: 1,
          },
        },
        toolbar: {
          autoSelected: "zoom",
        },
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        showForNullSeries: false,
        showForZeroSeries: true,
        position: "bottom",
        horizontalAlign: "center",
        floating: false,
        fontSize: "14px",
        fontFamily: "Helvetica, Arial",
        fontWeight: 400,
        formatter: undefined,
        inverseOrder: false,
        width: undefined,
        height: undefined,
        tooltipHoverFormatter: undefined,
        customLegendItems: [],
        offsetX: 0,
        offsetY: 0,
        labels: {
          colors: isdarkMode ? "#FFFFFF" : "#000000",
          useSeriesColors: false,
        },
        markers: {
          width: 12,
          height: 12,
          strokeWidth: 0,
          strokeColor: "#fff",
          fillColors: undefined,
          radius: 12,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0,
        },
        itemMargin: {
          horizontal: 5,
          vertical: 10,
        },
        onItemClick: {
          toggleDataSeries: true,
        },
        onItemHover: {
          highlightDataSeries: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 5,
        sizeOffset: 0,
        hover: {
          size: undefined,
          sizeOffset: 3,
        },
      },
     

      title: {

        text: "Live Trends Chart",


        style: {
          color: isdarkMode ? "#FFFFFF" : "#000000",
          fontSize: "18px",
          fontWeight: "bold",
        },
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            colors: isdarkMode ? ["#FFFFFF"] : ["#000000"],
          },
        },
        title: {
          text: "Date",
          style: {
            color: isdarkMode ? "#FFFFFF" : "#000000",
          },
        },
      },

      yaxis: {
        labels: {
          style: {
            colors: isdarkMode ? ["#FFFFFF"] : ["#000000"],
          },
        },
        title: {
          text: "Value",
          style: {
            color: isdarkMode ? "#FFFFFF" : "#000000",
          },
        },
      },

      responsive: [
        {
          breakpoint: 500,
          yaxis: {
            categories: [],
          },
        },
      ],
      tooltip: {
        x: {
          show: true,
          format: "dd MMM",
          formatter: undefined,
        },
        y: {
          title: {
            formatter: (
              seriesName,
              { series, seriesIndex, dataPointIndex, w }
            ) => {
              const isFlowRate = seriesName.includes("flowRate");
              const kgLabel = isFlowRate ? " Kg/hr" : "Kg";
              return seriesName + kgLabel;
            },
          },
        },
      },

      // noData: {
      //   // text: isLoading ? "Loading..." : "No Data present in the graph!",
      //   align: 'center',
      //   verticalAlign: 'middle',
      //   offsetX: 0,
      //   offsetY: 0,
      //   style: {
      //     color: "#000000",
      //     fontSize: '14px',
      //     fontFamily: "Helvetica"
      //   }
      // }
    },
  });

  useEffect(() => {
    setChartData((prevChartData) => ({
      series: seriesChartData || [],
      options: {
        ...prevChartData.options,
        title: {
          ...prevChartData.options.title,
          style: {
            color: isdarkMode ? "#FFFFFF" : "#000000",
            fontSize: "18px",
            fontWeight: "bold",
          },
        },
        xaxis: {
          ...prevChartData.options.xaxis,
          title: {
            style: {
              color: isdarkMode ? "#FFFFFF" : "#000000",
            },
          },
          labels: {
            style: {
              colors: isdarkMode ? ["#FFFFFF"] : ["#000000"],
            },
          },
        },
        yaxis: {
          ...prevChartData.options.yaxis,
          title: {
            ...prevChartData.options.yaxis.title,
            style: {
              color: isdarkMode ? "#FFFFFF" : "#000000",
            },
          },
          labels: {
            ...prevChartData.options.yaxis.labels,
            style: {
              colors: isdarkMode ? ["#FFFFFF"] : ["#000000"],
            },
          },
        },

        // grid: {
        //   borderColor: isdarkMode ? "#555555" : "#DDDDDD",
        //   strokeDashArray: 0,
        // },
      },
    }));
  }, [isdarkMode, seriesChartData]);

  //   GetsteamConverterLiveChart?SectionID=1&ConverterorGroupID=1&MeterIds=1&FromDate=2023-10-27%2007%3A15%3A00.000&Todate=2023-10-28%2007%3A15%3A00.000

  const fetchSteamConverterLive = (input) => {
    if (!input) return;

    const url = `${APIConstants.GET_STEAM_CONVERTER_LIVE_CHART}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=${input.FromDate}&Todate=${input.ToDate}`;
    console.log(url);

    // setIsLoading(true);

    makeRequest({
      type: APIConstants.GET,
      url: url,
    })
      .then((res) => {
        setSteamConverterLiveChartData(res);
        console.log(res);
      })
      .catch((error) => {
        console.error("Error fetching steam converter live chart data:", error);
      })
   
  };



  useEffect(() => {
    if (chartInput) {
      fetchSteamConverterLive(chartInput);
    }
  }, [chartInput]);

  //to fetch meter upon converter selection
  const fetchNsFlow = (id) => {
    makeRequest({
      type: APIConstants.GET,

      url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${id}`,
    }).then((res) => {
      console.log(res);
      setNsFlowConverterList(res);
    });
  };

  useEffect(() => {
    if (converterGroupId) {
      fetchNsFlow(converterGroupId);
    }
  }, [converterGroupId]);

  //to fetch metrs upon group selection
  const fetchGroupMeter = (id) => {
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${id}`,
    }).then((res) => {
      console.log(res);
      setSteamGroupMeterList(res);
    });
  };

  useEffect(() => {
    if (converterGroupId) {
      fetchGroupMeter(converterGroupId);
    }
  }, [converterGroupId]);

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_FLOW_SECTION_MASTER_DETAILS,
    }).then((res) => {
      console.log(res);
      setFlowSectionList(res);
    });

    makeRequest({
      type: APIConstants.GET,

      url: APIConstants.GET_FLOW_CONVERTER_DETAILS,
    }).then((res) => {
      console.log(res);
      setFlowConverterList(res);
    });

    makeRequest({
      type: APIConstants.GET,

      url: APIConstants.GET_STEAM_FLOW_GROUP_DETAILS,
    }).then((res) => {
      console.log(res);
      setFlowGroupDetailList(res);
    });
  }, []);

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const setChartInputData = () => {
    localStorage.setItem("secId", Number(sectionId || 1));
    localStorage.setItem("ConverterorGroupID", Number(converterGroupId || 3));
    localStorage.setItem("meterIds", JSON.stringify(selectedMeterIds || ["1"]));
    localStorage.setItem(
      "parameters",
      JSON.stringify(selectedValues || ["flowRate"])
    );

    const currentDate = new Date();
    // console.log(currentDate)
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    // console.log(from ,to)
    // console.log(currentDate)

    const lgSecId = localStorage.getItem("secId");
    const lgConvId = localStorage.getItem("ConverterorGroupID");
    const meterId = localStorage.getItem("meterIds");

    const inputIds = JSON.parse(meterId).map((item) => item);
    const ids = inputIds?.map((id) => id).join(",");

    const inputData = {
      SectionID: Number(lgSecId),
      ConverterorGroupID: Number(lgConvId),
      MeterIds: ids,
      FromDate: from ||"2023-10-28 16:14:54.533",
      ToDate: to || "2023-10-28 18:14:54.383",
    };

    const queryString = inputData;
    setChartInput(queryString);
  };

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    setSubmitClicked(false);
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    console.log(changedValues);
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    setSubmitClicked(false);
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    setSubmitClicked(false);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    setSubmitClicked(false);
    if (values) {
      setParaError("");
    }
  };

  useEffect(() => {
    setChartInputData();
  }, []);

  const updateChart = async (data) => {
    const meterId = localStorage.getItem("meterIds");
    const inputIds = JSON.parse(meterId)?.map((item) => item);
    


    console.log(inputIds)

    // filter data based on selected meters
    const filterMeterData = () => {
      const selectedMeterData = steamConverterLiveChartData?.filter((item) =>
        inputIds?.map((id) => Number(id)).includes(item?.meterid)
      );
      console.log(inputIds)
      return selectedMeterData;
    };

    // transform the data in a chart series format
    const transformData = (property, meterName) => {
      console.log(meterName)
      const data = filterMeterData()
        ?.filter((item) => item?.metername === meterName)
        ?.map((item) => item[property]);
      data?.reverse();

      const seriesData = {
        name: `${property}-${meterName}`, // Concatenate property and METERNAME
        data,
      };

      return seriesData;
    };

    const getChartSeriesData = () => {
      const properties = selectedValues?.length ? selectedValues : ["flowRate"];
      const seriesDataArray = [];

      // Iterate over selected meter IDs and properties
      inputIds?.forEach((id) => {
        const meterName = filterMeterData()?.find(
          (item) => item?.meterid === Number(id)
        )?.metername;

        properties.forEach((property) => {
          seriesDataArray.push(transformData(property, meterName));
        });
      });
      return seriesDataArray;
    };

    const getChartDate = () => {
      const dateArray = [];
      const date = ["createdON"];
      inputIds?.forEach((id) => {
        const meterName = filterMeterData()?.find(
          (item) => item?.meterid === Number(id)
        )?.metername;

        date?.forEach((property) => {
          dateArray.push(transformData(property, meterName));
        });
      });
      // Find the array with the maximum length
      const longestArray = dateArray.reduce((maxArray, currentArray) => {
        return currentArray?.data?.length > maxArray?.data?.length
          ? currentArray
          : maxArray;
      }, dateArray[0] || []);
      return longestArray?.data?.reverse();
    };

    const finalSeriesData = () => {
      const firstOption = selectedValues?.includes("flowRate");
      const secondOption = selectedValues?.includes("cumulative");

      const finalData = getChartSeriesData()?.filter((series) => {
        if (firstOption && secondOption) {
          // Both options selected, keep all series
          return true;
        } else if (firstOption) {
          // First option selected, add series with "FlowRate"
          return series.name.includes("flowRate");
        } else if (secondOption) {
          // Second option selected, add series with "Cumulative"
          return series.name.includes("cumulative");
        }
        // If neither option selected, keep all series
        return true;
      });
      return finalData;
    };

    const reversedDate = getChartDate();
    const localDateTime = reversedDate?.map((date) =>
      new Date(date).toLocaleString()
    );

    const finalSeries = finalSeriesData();
    setSingleMeterName(finalSeries[0]?.name);

    setSeriesChartData(finalSeries);
    setChartTime(localDateTime);
  };

  useEffect(() => {
    setChartSkip(false);
    updateChart();
    const interval = setInterval(() => {
      // refetchChart();
      updateChart();
    }, [600000]);

    return () => {
      clearInterval(interval);
    };
  }, [chartInput, steamConverterLiveChartData, selectedValues]);

  useEffect(() => {
    if (!steamConverterLiveChartData) {
      updateChart();
    }
  }, [steamConverterLiveChartData]);

  useEffect(() => {
    setChartData((prevChartData) => ({
      series: seriesChartData || [],
      options: {
        ...prevChartData.options,
        legend: {
          ...prevChartData.options.legend,
          labels: {
            ...prevChartData.options.legend.labels,
            colors: isdarkMode ? "#FFFFFF" : "#000000", 
          },
        },
        xaxis: {
          ...prevChartData.options.xaxis,
          categories: chartTime ? chartTime.reverse() : [], 
          labels: {
            ...prevChartData.options.xaxis.labels,
            style: {
              colors: isdarkMode ? "#FFFFFF" : "#000000", 
            },
          },
        },
        yaxis: {
          title: {
            text: selectedValues.join(","),
            style: {
              color: isdarkMode ? "#FFFFFF" : "#000000",
            },
          },
          labels: {
            style: {
              colors: isdarkMode ? "#FFFFFF" : "#000000",
            },
          },
        },
        title: {
          ...prevChartData.options.title,
          style: {
            color: isdarkMode ? "#FFFFFF" : "#000000",
          },
        },
       
      },
    }));
  }, [seriesChartData, chartTime, isdarkMode, selectedValues]); 
  

  const parameters = [
    { id: 1, name: "flowRate" },
    { id: 2, name: "cumulative" },
  ];

  const isInvalid = singleMeterName?.split("-");

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds, "Meter");
    const paraError = validateInput(selectedValues, "Parameter");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);

    if (!sectionError && !converterError && !meterError && !paraError) {

      setSubmitClicked(true);
      setIsFormSubmitted(true)
      setChartInputData();
      setIsLoading(false)
      onClose(); 
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (
        submitClicked &&
        converterGroupId &&
        sectionId &&
        selectedMeterIds?.length &&
        selectedValues?.length
      ) {
        setChartInputData();
      }
    }, 10000);
    return () => clearInterval(timer);
  }, [
    converterGroupId,
    sectionId,
    selectedMeterIds,
    submitClicked,
    selectedValues,
  ]);

  return (
    <div id="chart" className="relative">
      {isLoading  &&(
        <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10">
          <Spin active paragraph={{ rows: 6 }} />
        </div>
      )}

      <Card
        className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{ position: 'relative', overflow: 'hidden' }}
      >


        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="line"
          height={500}
          className="w-full"
        />


        {seriesChartData?.length === 1 && isInvalid[1] !== "undefined" && (
          <p className="text-center ml-16">{singleMeterName}</p>
        )}
      </Card>




      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
        className={`${isdarkMode ? "red" : "whitemode"} `}
      >
        <div className={`  flex flex-col space-y-2   `}>
          <CustomSelect
            label="Section:"
            options={flowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            className={` ${isdarkMode ? " select-dropdown-background  " : "custom-select-light"}  `}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={sectionId === 1 ? flowConverterList : flowGroupDetailList}
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "groupName"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={sectionId === 1 ? nsFlowConverterList : steamGroupMeterList}
            idKey={sectionId === 1 ? "meterid" : "meterID"}
            valueKey={sectionId === 1 ? "meterid" : "meterID"}
            nameKey={sectionId === 1 ? "metername" : "meterName"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
            dropdownClassName={
              isdarkMode ? "select-dropdown-background" : "light-mode-dropdown"
            }
          />

          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>

          <SteamTreeSelectCustom
            label="Parameters:"
            data={parameters}
            idKey="id"
            nameKey="name"
            valueKey="name"
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default SteamLiveChart;
